import { FITNESS_JOURNAL } from "../types/actions";

const initialState = {
	fitnessJournalSummary: [],
	fitnessJournal: [],
	fitnessGoals: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case FITNESS_JOURNAL.GET_FITNESS_JOURNAL_SUMMARY:
			return { ...state, fitnessJournalSummary: action.payload };
		case FITNESS_JOURNAL.GET_FITNESS_JOURNAL:
			return { ...state, fitnessJournal: action.payload };
		case FITNESS_JOURNAL.GET_FITNESS_GOALS:
			return { ...state, fitnessGoals: action.payload };
		case FITNESS_JOURNAL.SAVE_FITNESS_GOALS:
			return { ...state, fitnessGoals: action.payload };
		case FITNESS_JOURNAL.CREATE_FITNESS_GOALS:
			return { ...state, fitnessGoals: action.payload };
		case FITNESS_JOURNAL.CREATE_FITNESS_JOURNAL:
			return { ...state, fitnessJournal: action.payload };
		case FITNESS_JOURNAL.EDIT_FITNESS_JOURNAL:
			return { ...state, fitnessJournal: action.payload };
		case FITNESS_JOURNAL.DELETE_FITNESS_JOURNAL:
			return { ...state, fitnessJournal: action.payload };
		default:
			return state;
	}
};
